import React from 'react';

import {Button, Spinner} from 'player-components';
import './style.css';
import Lottie from 'react-lottie';
import studioAnimationData from '../../lotties/studio.json';
import notesAnimationData from '../../lotties/notes.json';
import genericAnimationData from '../../lotties/generic.json';


const LoadingScreen = ({animationFile, title, text, loadingProgress, totalSteps, onCancel}) => {
  const getAnimationFile = () => {
    switch (animationFile) {
      case 'studio':
       return studioAnimationData;
      case 'notes':
        return notesAnimationData;
      case 'generic':
        return genericAnimationData;
      default:
        return studioAnimationData;
    }
  }


return <div className="loadingScreenContainer" >
    {/* <h2 className="text-center text-secondary-600 dark:text-secondary-300 text-lg pb-1 mb-2" >{title}</h2>
    <p className="text-center text-secondary-600 dark:text-secondary-300 text-lg pb-1 mb-2">{text}</p> */}
    {/* <Button onClick={onCancel}>CANCEL</Button> */}
    
      <h4 className="sr-only">Status</h4>
      <Lottie 
	      options={{
          loop: true,
          autoplay: true,
          animationData: getAnimationFile(),
          rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
          }
        }}
        height={200}
        width={200}
      />
      <p className="text-sm font-medium dark:text-white ">{text}</p>
      <div className="mt-4 w-40 mb-4" aria-hidden="true">
        <div className="bg-transparent rounded-full border border-primary overflow-hidden h-4">
          <div className="bg-primary rounded-full h-full" style={{ width: `${Number(loadingProgress.downloadPercentage) * 0.9}%` }}></div>
        </div>
        <div className="text-sm font-medium text-center"><span>{(loadingProgress.downloadPercentage * 0.9).toFixed(0)}%</span></div>
      </div>
      <Button type="primary" onClick={onCancel}>Cancel</Button>
    </div>
      }


export default LoadingScreen;